import type { Locale } from './config'

export const notoSansScClassName = 'font-noto-sans-sc'

/** Extra html class for Simplified Chinese glyph fallback. Empty on every other locale. */
export function getLocaleFontClassNames(locale: Locale): string {
  return locale === 'zh' ? notoSansScClassName : ''
}

/** Blocking script: Next 16 does not forward proxy `x-locale` into Server Components. */
export function getLocaleFontClassInitScript(notoVariableClass: string): string {
  return `(function(){var segment=location.pathname.split("/")[1]||"";if(segment==="zh"){document.documentElement.classList.add(${JSON.stringify(notoVariableClass)},${JSON.stringify(notoSansScClassName)})}})()`
}
